/**
 * @deprecated This file is deprecated. Import from services/api/supabase.service.js instead
 * Kept for backward compatibility - re-exports from SupabaseService
 */

import { supabase as supabaseClient } from './services/api/supabase.service';

export const supabase = supabaseClient;
